/*=========================================================================================
  File Name: getters.js
  Description: Vuex Store - getters
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

// added so later we can keep breakpoint in sync automatically using this config file
// import tailwindConfig from "../../tailwind.config.js"

const getters = {

	// COMPONENT
		// vx-autosuggest
	// starredPages: state => state.navbarSearchAndPinList.data.filter((page) => page.highlightAction),
  windowBreakPoint: state => {

    // This should be same as tailwind. So, it stays in sync with tailwind utility classes
    if (state.windowWidth >= 1200) return "xl"
    else if (state.windowWidth >= 992) return "lg"
    else if (state.windowWidth >= 768) return "md"
    else if (state.windowWidth >= 576) return "sm"
    else return "xs"
  },

  scrollbarTag: state => {
    return state.is_touch_device ? 'div' : 'VuePerfectScrollbar'
  },

  // true cuando la carpeta activa no es propiedad del usuario (rol 'invited'/'operator'),
  // es decir, está trabajando dentro de una carpeta compartida por otro dueño.
  isSharedCompany: state => {
    const selectedCompany = state.account.user.me && state.account.user.me.selected_company
    return Boolean(selectedCompany && selectedCompany.role && selectedCompany.role !== 'owner')
  },

  // Firmas disponibles del dueño de la carpeta activa. Sale del detalle cacheado en
  // companies/currentCompany, que se refresca al cambiar de carpeta y tras cada
  // acción de documentos que consume o libera firmas.
  ownerAvailableCredits: state => {
    const current = state.companies ? state.companies.currentCompany : null
    return current && current.owner_available_credits !== undefined && current.owner_available_credits !== null
      ? current.owner_available_credits
      : null
  }
}

export default getters
